export const IsSettlement = {
    No: { value: "0", name: "No", color: "danger" },
    YES: { value: "1", name: "Yes", color: "success" },
};

export interface RePayCreateOrder {
    applicationId: number;
    amount: number;
    isForeClose?: boolean;
    payId?: any;
}

export interface RazorpayOption {
    key: string;
    customer_id: number;
    order_id: string;
    name: string;
    image: string;
    theme: {
        color: string;
    };
    prefill: {
        contact: string;
    };
    notes: string;
    handler: any;
    modal: any;
}

export enum IsPartPayment {
    NO = "0",
    YES = "1",
}

export enum PaymentStatus {
    YES = "1",
    NO = "2",
}

export enum RepaymentStatus {
    PENDING = "0",
    DONE = "1",
}

export interface RazorpayCallback {
    applicationId: number;
    paymentId: string;
    orderId: string;
    signature?: string;
    status: PaymentStatus;
}

export interface RewardWalletClaim {
    applicationId: string;
    points: number;
    type: string;
}

export enum WalletUsedType {
    PF = "0",
    REPAYMENT = "1",
}

export enum DiscountTypeEnum {
    PROMO = "1",
    MANUAL_DISCOUNT = "2",
    REFERRAL_DISCOUNT = "3",
    COUPON_CODE_DISCOUNT = "4",
    REWARD_WALLET = "5",
    WAIVER = "6",
}

export enum CouponType {
    ALL = "0",
    PROCESSING = "1",
    REPAYMENT = "2",
}

export interface CouponRedeem {
    code: string;
    couponType: string;
    amount: number;
}

export enum RepaymentOption {
    EMI = "EMI",
    CUSTOM = "CUSTOM",
    FORECLOSE = "FORECLOSE",
}
